const ScrollNext = () => (
  <div id="kh-next">
    <button type="button" className="kh-bounce" data-scroll-next="" aria-label="تابع النزول في الصفحة" style={{ position: "fixed", bottom: "24px", left: "24px", zIndex: "55", width: "56px", height: "56px", borderRadius: "50%", border: "0", cursor: "pointer", background: "#FFC93C", boxShadow: "0 6px 0 #C48E00, 0 14px 30px rgba(11,18,64,0.3)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>
  </div>
);

export default ScrollNext;
